import React from 'react';
import styles from './enrichment-dns-records.module.sass';
import { Button, Typography, Table, Tooltip } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { Link } from 'react-router-dom';

function EnrichmentDnsRecords({
  history,
  newData,
  statusNew,
  // dnsRecords,
  // dnsStatus,
  ARecordsDomainEnrichmentData,
  ARecordsDomainEnrichmentStatus,
  AAAARecordsDomainEnrichmentData,
  AAAARecordsDomainEnrichmentStatus,
  CNAMERecordsDomainEnrichmentData,
  CNAMERecordsDomainEnrichmentStatus,
  MXRecordsDomainEnrichmentData,
  MXRecordsDomainEnrichmentStatus,
  NSRecordsDomainEnrichmentData,
  NSRecordsDomainEnrichmentStatus,
  SOARecordsDomainEnrichmentData,
  SOARecordsDomainEnrichmentStatus,
  TXTRecordsDomainEnrichmentData,
  TXTRecordsDomainEnrichmentStatus,
  ipDensity,
  ipDensityStatus,
  PTRLookup,
  PTRLookupStatus,
  type,
  parsedData,
  props,
}) {
  const { Title, Text } = Typography;
  const ptrLookupArray = PTRLookup?.response?.records;

  let ipDensityCount = 0;
  let totalIpDNSRecords = 0;
  let totalDomainDNSRecords = 0;
  let iocName;

  if (type === 'domain') {
    iocName = newData?.response?.domaininfo?.query ?? parsedData?.result;
  } else if (type === 'ipv4') {
    if (ipDensity?.response?.records?.[0]) {
      ipDensityCount = ipDensity?.response?.records?.[0]?.density;
    }
    if (newData?.response?.ip2asn) {
      iocName = newData?.response?.ip2asn?.[0]?.ip ?? parsedData?.result;
    } else if (!newData?.response?.ip2asn) {
      iocName = parsedData?.result;
    }
  }

  function returnTotalDomainDNSRecords() {
    totalDomainDNSRecords =
      (ARecordsDomainEnrichmentData?.response?.records?.length > 0
        ? ARecordsDomainEnrichmentData?.response?.records?.length
        : 0) +
      (AAAARecordsDomainEnrichmentData?.response?.records?.length > 0
        ? AAAARecordsDomainEnrichmentData?.response?.records?.length
        : 0) +
      (CNAMERecordsDomainEnrichmentData?.response?.records?.length > 0
        ? CNAMERecordsDomainEnrichmentData?.response?.records?.length
        : 0) +
      (MXRecordsDomainEnrichmentData?.response?.records?.length > 0
        ? MXRecordsDomainEnrichmentData?.response?.records?.length
        : 0) +
      (NSRecordsDomainEnrichmentData?.response?.records?.length > 0
        ? NSRecordsDomainEnrichmentData?.response?.records?.length
        : 0) +
      (SOARecordsDomainEnrichmentData?.response?.records?.length > 0
        ? SOARecordsDomainEnrichmentData?.response?.records?.length
        : 0) +
      (TXTRecordsDomainEnrichmentData?.response?.records?.length > 0
        ? TXTRecordsDomainEnrichmentData?.response?.records?.length
        : 0);

    return totalDomainDNSRecords;
  }

  function returnTotalIpDNSRecords() {
    if (ipDensityCount) {
      totalIpDNSRecords += ipDensityCount;
    }
    if (ptrLookupArray) {
      totalIpDNSRecords += ptrLookupArray?.length;
    }
    return totalIpDNSRecords;
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      className: styles.name_column,
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'amount',
      className: 'ant-column-white',
      render: (amount) => (amount ? amount : '-'),
    },
    {
      dataIndex: 'value',
    },
  ];

  function returnTableData({ skeleton, iocType }) {
    if (iocType === 'domain') {
      return [
        {
          key: '1',
          name: 'A',
          amount:
            ARecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : ARecordsDomainEnrichmentData?.response?.records?.length > 0 ? (
              ARecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            ARecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'answer' : 'query'
                  }&type=A&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
        {
          key: '2',
          name: 'AAAA',
          amount:
            AAAARecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : AAAARecordsDomainEnrichmentData?.response?.records?.length >
              0 ? (
              AAAARecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            AAAARecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'query' : 'query'
                  }&type=AAAA&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
        {
          key: '3',
          name: 'CNAME',
          amount:
            CNAMERecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : CNAMERecordsDomainEnrichmentData?.response?.records?.length >
              0 ? (
              CNAMERecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            CNAMERecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'query' : 'query'
                  }&type=CNAME&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
        {
          key: '4',
          name: 'NS',
          amount:
            NSRecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : NSRecordsDomainEnrichmentData?.response?.records?.length > 0 ? (
              NSRecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            NSRecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'query' : 'query'
                  }&type=NS&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
        {
          key: '5',
          name: 'MX',
          amount:
            MXRecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : MXRecordsDomainEnrichmentData?.response?.records?.length > 0 ? (
              MXRecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            MXRecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'query' : 'query'
                  }&type=MX&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
        {
          key: '6',
          name: 'SOA',
          amount:
            SOARecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : SOARecordsDomainEnrichmentData?.response?.records?.length >
              0 ? (
              SOARecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            SOARecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'query' : 'query'
                  }&type=SOA&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
        {
          key: '7',
          name: 'TXT',
          amount:
            TXTRecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : TXTRecordsDomainEnrichmentData?.response?.records?.length >
              0 ? (
              TXTRecordsDomainEnrichmentData?.response?.records?.length
            ) : (
              '-'
            ),
          value:
            TXTRecordsDomainEnrichmentStatus !== 'loaded' ? (
              <LoadingSkeleton />
            ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    iocName ?? parsedData?.result
                  }&queryType=${
                    type === 'ipv4' ? 'query' : 'query'
                  }&type=TXT&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            ),
        },
      ];
    }
    if (iocType === 'ipv4') {
      return [
        {
          key: '1',
          name: 'A',
          amount: skeleton ? (
            <LoadingSkeleton />
          ) : ipDensityCount ? (
            ipDensityCount
          ) : (
            '-'
          ),
          value: skeleton ? (
            <LoadingSkeleton />
          ) : (
            <Link
              to={
                `/explore-result?name=${
                  iocName ?? parsedData?.result
                }&queryType=${
                  type === 'ipv4' ? 'answer' : 'query'
                }&type=A&backLink=` +
                encodeURIComponent(window.location.pathname) +
                encodeURIComponent(window.location.search) +
                '&origin_uid=Explore'
              }
            >
              <Button type="primary">Lookup PADNS</Button>
            </Link>
          ),
        },
        {
          key: '2',
          name: 'PTR',
          amount: skeleton ? (
            <LoadingSkeleton />
          ) : ptrLookupArray?.length > 0 ? (
            ptrLookupArray?.length
          ) : (
            '-'
          ),
          value: skeleton ? (
            <LoadingSkeleton />
          ) : (
            <Link
              to={
                `/explore-result?name=${
                  iocName ?? parsedData?.result
                }&queryType=${
                  type === 'ipv4' ? 'query' : 'query'
                }&type=PTR4&backLink=` +
                encodeURIComponent(window.location.pathname) +
                encodeURIComponent(window.location.search) +
                '&origin_uid=Explore'
              }
            >
              <Button type="primary">Lookup PADNS</Button>
            </Link>
          ),
        },
      ];
    }
  }

  return (
    <div className={styles.enrichment_dns_records}>
      <div className={styles.title}>
        <Title level={4}>DNS Records</Title>
        <Text>Most recent records found</Text>
      </div>

      <Table
        className={styles.dns_table}
        columns={columns}
        dataSource={returnTableData({
          skeleton: !(
            statusNew === 'loaded' &&
            ipDensityStatus === 'loaded' &&
            PTRLookupStatus === 'loaded'
          ),
          iocType: type,
        })}
        pagination={false}
        footer={() => {
          return statusNew === 'loaded' &&
            ((ARecordsDomainEnrichmentStatus === 'loaded' &&
              AAAARecordsDomainEnrichmentStatus === 'loaded' &&
              CNAMERecordsDomainEnrichmentStatus === 'loaded' &&
              MXRecordsDomainEnrichmentStatus === 'loaded' &&
              NSRecordsDomainEnrichmentStatus === 'loaded' &&
              SOARecordsDomainEnrichmentStatus === 'loaded' &&
              TXTRecordsDomainEnrichmentStatus === 'loaded') ||
              (ipDensityStatus === 'loaded' &&
                PTRLookupStatus === 'loaded')) ? (
            ptrLookupArray?.length > 0 || ipDensityCount >= 0 ? (
              <>
                <Text>Total most recent records found - </Text>
                <Text className={styles.dns_count} strong>
                  {type === 'domain' && returnTotalDomainDNSRecords()}
                  {type === 'ipv4' && returnTotalIpDNSRecords()}
                </Text>
              </>
            ) : (
              '-'
            )
          ) : (
            <LoadingSkeleton />
          );
        }}
      />
    </div>
  );
}

export default EnrichmentDnsRecords;
